
export default {
    name: 'assurance-groupes',
    components: {},
    props: [],
    data() {
        return {
            is_loading: true,
            assur_loading: true,
            assur_is_empty: false,
            groupe_id: 0,

            l_assurance: [],

            save_loading: false,
            btn_disable: false,
        }
    },
    computed: {
        groupe_assur() {
            return this.$store.getters["groupe_assur"];
        },

        compagnie_assurances() {
            return this.$store.getters["compagnie_assurances"];
        },
    },
    mounted() {
        this.groupe_id = this.$route.params.id
        this.$store.dispatch("getGroupeAssuranceById", this.$route.params.id).then(() => {
			this.is_loading = false
		});

        this.refreshAssurGroupeList()
    },
    methods: {
        refreshAssurGroupeList() {
            this.assur_loading = true
            this.$store.dispatch("getAssurance").then(() => {
                console.log("ASSURS: ",this.compagnie_assurances)
                this.assur_loading = false
                if(this.compagnie_assurances.length > 0) {
                    this.assur_is_empty = false
    
                    this.fillUpAssignedAssur()
                } else {
                    this.assur_is_empty = true
                }
            });
        },

        fillUpAssignedAssur() {
            let len = this.compagnie_assurances.length

            for(let i = 0; i < len; i++) {
                if (this.compagnie_assurances[i].assurance_groupe_id == this.$route.params.id) {
                    let assur = {
                        id: this.compagnie_assurances[i].id,
                        assurance: this.compagnie_assurances[i].raison_sociale
                    }
                    this.l_assurance.push(assur)
                }
            }
        },

        assignGroup(assurance) {
            let j = 0
            let len = this.l_assurance.length

            // Verifier si motif déjà choisi
            if (len > 0) {
                console.log("-->>>>>Before ",this.l_assurance)
                for(let i = 0; i < len; i++) {
                    console.log("-->>>>> ",assurance.id,"  === ",this.l_assurance[i]['id'])
                    if(assurance.id == this.l_assurance[i]['id']) {
                        j++;

                        let confirm = document.getElementById('gassur'+assurance.id);
                        if (confirm.checked == false) {
                            this.removeAssur(i)
                        } 
                    }
                }
            }
            if (j == 0) {
                let assur = {
                    id: assurance.id,
                    assurance: assurance.raison_sociale
                }
                this.l_assurance.push(assur)
            }
            console.log("-->>>>> ",this.l_assurance)
        },

        removeAssur(index) {
            this.l_assurance.splice(index, 1)
        },

        submit() {
            this.save_loading = true
            this.btn_disable = true

            let data = {
                groupe_id: this.$route.params.id,
                assurs: this.l_assurance
            }

            this.$store.dispatch('assignGroupToAssurance', data).then((response) => {
                if (response > 0) {
                    this.successMsg("Enregistrement effectué avec succès.")
                    this.refreshAssurGroupeList()
                }

                this.save_loading = false
                this.btn_disable = false
            })
        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },
    }
}